import supabase from '../supabase/supabase';

const FROM_EMAIL = 'noreply@app.dayclap.com';
const FROM_NAME = 'DayClap';
const LOGO_URL = 'https://cloud.sharemyimage.com/2026/08/16/DayClap-Logo.png';
const APP_ICON_URL = 'https://cloud.sharemyimage.com/2026/08/16/App-Icon.png';
const APP_URL = 'https://dayclap.com';
const GRADIENT = 'background: linear-gradient(135deg, #ec4899, #f43f5e)';

// Prominent circular logo header used in all emails
const LOGO_HEADER = `
<div style="text-align: center; margin-bottom: 36px;">
  <div style="display: inline-block; width: 120px; height: 120px; border-radius: 50%; overflow: hidden; border: 4px solid #fce7f3; box-shadow: 0 4px 20px rgba(236, 72, 153, 0.15);">
    <img src="${APP_ICON_URL}" alt="DayClap" style="width: 120px; height: 120px; object-fit: cover; display: block;">
  </div>
  <div style="margin-top: 16px;">
    <img src="${LOGO_URL}" alt="DayClap" style="height: 36px;">
  </div>
</div>`;

const EMAIL_FOOTER = `
<div style="text-align: center; margin-top: 40px; padding-top: 24px; border-top: 1px solid #f3f4f6;">
  <img src="${APP_ICON_URL}" alt="" style="width: 64px; height: 64px; border-radius: 16px; margin-bottom: 8px;">
  <p style="color: #9ca3af; font-size: 12px; margin: 0;">Create something special for someone special. ❤️</p>
  <p style="color: #d1d5db; font-size: 11px; margin: 8px 0 0 0;">DayClap · dayclap.com</p>
</div>`;

export const sendEmail = async ({ to, subject, html, variables = {} }) => {
  try {
    const { data, error } = await supabase.functions.invoke('send-email', {
      body: { to, subject, html, variables }
    });
    if (error) {
      console.error('[emailService] Error:', error);
      return { success: false, error: error.message };
    }
    return { success: true, data };
  } catch (err) {
    console.error('[emailService] Unexpected error:', err);
    return { success: false, error: err.message };
  }
};

export const sendTestEmail = async (recipientEmail) => {
  const timestamp = new Date().toLocaleString();
  return sendEmail({
    to: recipientEmail,
    subject: 'DayClap Email Test ✅',
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}
      <div style="background: #f0fdf4; border: 1px solid #bbf7d0; border-radius: 16px; padding: 24px; text-align: center; margin-bottom: 24px;">
        <p style="font-size: 32px; margin: 0 0 8px 0;">✅</p>
        <h2 style="color: #166534; font-size: 20px; margin: 0 0 8px 0;">Email Sending is Working!</h2>
        <p style="color: #15803d; font-size: 14px; margin: 0;">This is a test email from DayClap admin panel.</p>
      </div>
      <div style="background: #f9fafb; border-radius: 12px; padding: 20px; margin: 24px 0;">
        <p style="color: #6b7280; font-size: 13px; margin: 0 0 8px 0;"><strong>Details:</strong></p>
        <p style="color: #6b7280; font-size: 13px; margin: 0 0 4px 0;">• Sent to: ${recipientEmail}</p>
        <p style="color: #6b7280; font-size: 13px; margin: 0 0 4px 0;">• Sent at: ${timestamp}</p>
        <p style="color: #6b7280; font-size: 13px; margin: 0;">• Service: Emailit API via Supabase Edge Function</p>
      </div>
      ${EMAIL_FOOTER}
    </div>`
  });
};

export const sendConfirmationEmail = async (userEmail, userName, confirmUrl) => {
  return sendEmail({
    to: userEmail,
    subject: 'Welcome to DayClap! Confirm your email ❤️',
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}

      <h1 style="color: #1f2937; font-size: 28px; text-align: center; margin: 0 0 8px 0;">
        Welcome to DayClap, ${userName}! ❤️
      </h1>
      <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">
        We're so happy you're here. DayClap is where you create beautiful, personalized invitations for the people who matter most.
      </p>

      <div style="text-align: center; margin: 36px 0;">
        <a href="${confirmUrl}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">
          Confirm Your Email ✓
        </a>
      </div>

      <div style="background: #fdf2f8; border-radius: 16px; padding: 24px; margin: 24px 0;">
        <p style="color: #831843; font-size: 14px; text-align: center; margin: 0 0 12px 0; font-weight: 600;">
          After confirming, here's what you can do:
        </p>
        <table style="width: 100%; border-collapse: collapse;">
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">✨ Create your first invitation</td></tr>
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">💌 Personalize it with photos, music & effects</td></tr>
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">❤️ Send it to someone special</td></tr>
        </table>
      </div>

      <div style="background: #f9fafb; border-radius: 12px; padding: 16px; margin: 24px 0;">
        <p style="color: #6b7280; font-size: 13px; text-align: center; margin: 0;">
          If the button doesn't work, copy and paste this link:<br>
          <span style="color: #ec4899; word-break: break-all;">${confirmUrl}</span>
        </p>
      </div>

      <p style="color: #9ca3af; font-size: 13px; text-align: center; margin-top: 32px;">
        If you didn't create this account, you can safely ignore this email.
      </p>

      ${EMAIL_FOOTER}
    </div>`,
    variables: { name: userName, email: userEmail, confirm_url: confirmUrl }
  });
};

export const sendWelcomeEmail = async (userEmail, userName) => {
  return sendEmail({
    to: userEmail,
    subject: 'Welcome to DayClap! ❤️',
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}
      <h1 style="color: #1f2937; font-size: 28px; text-align: center; margin: 0 0 8px 0;">Welcome to DayClap, ${userName}! ❤️</h1>
      <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">We're so happy you're here. DayClap is where you create beautiful, personalized invitations for the people who matter most.</p>
      <div style="background: #fdf2f8; border-radius: 16px; padding: 24px; margin: 24px 0;">
        <p style="color: #831843; font-size: 14px; text-align: center; margin: 0 0 12px 0; font-weight: 600;">Here's what you can do:</p>
        <table style="width: 100%; border-collapse: collapse;">
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">✨ Create your first invitation</td></tr>
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">💌 Personalize it with photos, music & effects</td></tr>
          <tr><td style="padding: 8px 0; color: #9d174d; font-size: 13px;">❤️ Send it to someone special</td></tr>
        </table>
      </div>
      <div style="text-align: center; margin: 36px 0;">
        <a href="${APP_URL}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 44px; border-radius: 12px; font-weight: bold; font-size: 17px;">Go to DayClap ✨</a>
      </div>
      ${EMAIL_FOOTER}
    </div>`,
    variables: { name: userName, email: userEmail, app_url: APP_URL }
  });
};

export const sendForgotPasswordEmail = async (userEmail, userName, resetUrl) => {
  const resetLink = resetUrl || `${APP_URL}/reset-password`;
  return sendEmail({
    to: userEmail,
    subject: 'Reset your DayClap password',
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}
      <h1 style="color: #1f2937; font-size: 24px; text-align: center;">Reset Your Password</h1>
      <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi ${userName || 'there'}, we received a request to reset your DayClap password.</p>
      <div style="text-align: center; margin: 32px 0;">
        <a href="${resetLink}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 40px; border-radius: 12px; font-weight: bold; font-size: 17px;">Reset Password</a>
      </div>
      <div style="background: #fef3c7; border-radius: 12px; padding: 16px; margin: 24px 0;">
        <p style="color: #92400e; font-size: 13px; text-align: center; margin: 0;">
          ⚠️ This link expires in 1 hour. If you didn't request this, you can safely ignore this email.
        </p>
      </div>
      ${EMAIL_FOOTER}
    </div>`,
    variables: { name: userName, reset_url: resetLink }
  });
};

export const sendInvitationEmail = async (recipientEmail, senderName, recipientName, occasion, inviteUrl, eventDate) => {
  const dateSection = eventDate
    ? `<div style="background: #f3e8ff; border: 1px solid #e9d5ff; border-radius: 12px; padding: 16px; margin: 16px 0; text-align: center;">
        <p style="color: #7c3aed; font-size: 13px; margin: 0 0 4px 0; font-weight: 600;">📅 Proposed Date</p>
        <p style="color: #6d28d9; font-size: 16px; font-weight: bold; margin: 0;">${new Date(eventDate + 'T00:00:00').toLocaleDateString('en-US', { weekday: 'long', month: 'long', day: 'numeric' })}</p>
      </div>`
    : '';

  return sendEmail({
    to: recipientEmail,
    subject: 'You have a special invitation! 💌',
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}
      <h1 style="color: #1f2937; font-size: 24px; text-align: center;">You have something special! 💌</h1>
      <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">Hi ${recipientName}, ${senderName} created a special invitation just for you.</p>
      <div style="background: #fdf2f8; padding: 24px; border-radius: 16px; margin: 24px 0; text-align: center;">
        <p style="color: #831843; font-size: 14px; margin: 0;">${occasion}</p>
      </div>
      ${dateSection}
      <div style="text-align: center; margin: 32px 0;">
        <a href="${inviteUrl}" style="display: inline-block; ${GRADIENT}; color: white; text-decoration: none; padding: 18px 40px; border-radius: 12px; font-weight: bold; font-size: 17px;">Open Invitation ❤️</a>
      </div>
      ${EMAIL_FOOTER}
    </div>`,
    variables: { recipient_name: recipientName, sender_name: senderName, occasion, invite_url: inviteUrl }
  });
};

export const sendResponseNotification = async (senderEmail, senderName, recipientName, occasion, accepted) => {
  const subject = accepted ? "It's a YES! 🎉❤️" : 'Invitation update';
  const message = accepted
    ? `Great news, ${senderName}! ${recipientName} accepted your ${occasion} invitation.`
    : `${senderName}, your ${occasion} invitation to ${recipientName} was declined.`;

  return sendEmail({
    to: senderEmail,
    subject,
    html: `<div style="font-family: -apple-system, BlinkMacSystemFont, sans-serif; max-width: 600px; margin: 0 auto; padding: 40px 20px; background: #ffffff;">
      ${LOGO_HEADER}
      <h1 style="color: #1f2937; font-size: 24px; text-align: center;">${accepted ? "It's a YES! 🎉❤️" : 'Invitation Update'}</h1>
      <p style="color: #6b7280; font-size: 16px; line-height: 1.6; text-align: center;">${message}</p>
      ${EMAIL_FOOTER}
    </div>`,
    variables: { sender_name: senderName, recipient_name: recipientName, occasion }
  });
};

export const getEmailTemplates = async () => {
  const { data, error } = await supabase
    .from('email_templates')
    .select('*')
    .order('created_at', { ascending: false });
  if (error) {
    console.error('[emailService] Error fetching templates:', error);
    return { success: false, error: error.message, data: [] };
  }
  return { success: true, data };
};

export const updateEmailTemplate = async (id, updates) => {
  const { data, error } = await supabase
    .from('email_templates')
    .update({ ...updates, updated_at: new Date().toISOString() })
    .eq('id', id)
    .select()
    .single();
  if (error) {
    console.error('[emailService] Error updating template:', error);
    return { success: false, error: error.message };
  }
  return { success: true, data };
};

export const createEmailTemplate = async (template) => {
  const { data, error } = await supabase
    .from('email_templates')
    .insert(template)
    .select()
    .single();
  if (error) {
    console.error('[emailService] Error creating template:', error);
    return { success: false, error: error.message };
  }
  return { success: true, data };
};

export const deleteEmailTemplate = async (id) => {
  const { error } = await supabase
    .from('email_templates')
    .delete()
    .eq('id', id);
  if (error) {
    console.error('[emailService] Error deleting template:', error);
    return { success: false, error: error.message };
  }
  return { success: true };
};